/**
 * Events domain — admin UI registration (Sub-project III, Task 7).
 *
 * Injects per-record action toolbars into the generic-framework
 * detail pages via the `detailHeader` slot.
 */
import { registerAdminUI } from '@/admin/generic/registry';
import EventActions from './components/EventActions.vue';

registerAdminUI('events.events', {
    slots: {
        detailHeader: EventActions,
    },
});
